import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { z } from "zod";
import { ZodExtended } from "@/data/zod.extended";
import { PublicProjectsModels } from "./publicProjects.models";
import { CommonModels } from "@/data/common/common.models";

export namespace PublicProjectsApi {
export const getProjects = (userId: string, limit: number, order?: string, filter?: CommonModels.ProjectPaginationFilterDto, page?: number, cursor?: string, ) => { 
    return AppRestClient.get( 
        { resSchema: PublicProjectsModels.GetProjectsResponseSchema }, 
        `/public/profile/${userId}/projects`,
        {
    params: {
        order: ZodExtended.parse(z.string().nullish(), order, { type: "query", name: "order" })
, 
        filter: ZodExtended.parse(CommonModels.ProjectPaginationFilterDtoSchema.optional(), filter, { type: "query", name: "filter" })
, 
        limit: ZodExtended.parse(z.number().gte(1).lte(100).default(10), limit, { type: "query", name: "limit" })
, 
        page: ZodExtended.parse(z.number().nullish(), page, { type: "query", name: "page" })
, 
        cursor: ZodExtended.parse(z.string().nullish(), cursor, { type: "query", name: "cursor" })
, 
    },
}
    )
};

export const getFeaturedProject = (userId: string, ) => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProjectWithMediaDtoSchema }, 
        `/public/profile/${userId}/projects/featured`,
        
    )
};

export const show = (userId: string, id: string, ) => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProjectDtoSchema }, 
        `/public/profile/${userId}/projects/${id}`,
        
    )
};

export const getMedia = (userId: string, id: string, ) => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProjectMediaDtoSchema }, 
        `/public/profile/${userId}/projects/${id}/media`,
        
    )
};

}
